import { render, staticRenderFns } from "./aboutMoreSwiper.vue?vue&type=template&id=5df70354&scoped=true&"
import script from "./aboutMoreSwiper.vue?vue&type=script&lang=js&"
export * from "./aboutMoreSwiper.vue?vue&type=script&lang=js&"
import style0 from "./aboutMoreSwiper.vue?vue&type=style&index=0&id=5df70354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df70354",
  null
  
)

export default component.exports